import { render } from "./PendingPaymentsPage.vue?vue&type=template&id=06863b36&scoped=true"
import script from "./PendingPaymentsPage.vue?vue&type=script&lang=js"
export * from "./PendingPaymentsPage.vue?vue&type=script&lang=js"

import "./PendingPaymentsPage.vue?vue&type=style&index=0&id=06863b36&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06863b36"]])

export default __exports__